import React from 'react';
import { FieldImage, Fit, Text, fs } from '../parts/fields';
import { Logo, useFieldSize } from '../parts/chrome';
import { bool, str, useSlide } from '../parts/context';

// #region ImageLayout
/** A full image. `dark`: edge to edge with white text over a scrim. Otherwise framed, with the words under it. */
export const ImageLayout: React.FunctionComponent = (): React.ReactElement => {
    const { slide, edit } = useSlide();
    const dark = bool(slide.fields.dark);
    const size = useFieldSize('title', [[30, 80], [60, 68], [999, 58]]);
    const hasWords = edit || !!str(slide.fields.title).trim() || !!str(slide.fields.caption).trim();
    if (dark) {
        return (
            <>
                <FieldImage k="image" label="Add a full-bleed image" style={{ position: 'absolute', inset: 0, borderRadius: 0 }} />
                {hasWords ? <div aria-hidden="true" style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(0,0,0,0) 38%, rgba(0,0,0,.66) 100%)', pointerEvents: 'none' }} /> : null}
                <div className="wd-pad wd-on-dark" style={{ justifyContent: 'flex-end', pointerEvents: 'none' }}>
                    <div style={{ maxWidth: 1240, pointerEvents: 'auto' }}>
                        <Text k="title" as="h2" className="wd-h" style={{ fontSize: fs(size), textShadow: '0 2px 24px rgba(0,0,0,.25)' }} placeholder="Title (optional)" max={90} />
                        <Text k="caption" className="wd-lead" style={{ fontSize: 30, marginTop: 24 }} placeholder="Caption (optional)" max={200} />
                    </div>
                </div>
                <Logo dark style={{ left: 'auto', right: 64, bottom: 56 }} />
            </>
        );
    }
    return (
        <>
            <div className="wd-pad" style={{ paddingTop: 72, paddingBottom: 112 }}>
                <FieldImage k="image" framed label="Add an image" style={{ flex: 1, minHeight: 0 }} />
                {hasWords ? (
                    <Fit style={{ flex: 'none', maxHeight: 220, display: 'flex', gap: 80, alignItems: 'flex-start', marginTop: 44 }}>
                        <Text k="title" as="h2" className="wd-h" style={{ fontSize: fs(Math.min(size, 60)), flex: '1 1 50%', minWidth: 0 }} placeholder="Title (optional)" max={90} />
                        <Text k="caption" className="wd-lead wd-muted" style={{ fontSize: fs(28), flex: '1 1 40%', minWidth: 0, paddingTop: 6 }} placeholder="Caption (optional)" max={200} />
                    </Fit>
                ) : null}
            </div>
            <Logo />
        </>
    );
};
